export function requestPermissions() { }

export function abandonPermissions() { }

export function setApplicationIconBadgeCount(count) { }